export const Theme = {
  colors: {
    primary: '#072928',            // Brand teal-green
    secondary: '#B6B9DA',          // Cool gray-lavender
    background: '#FFFFFF',
    grounding: '#011F1E',          // Deeper grounding than primary

    button: {
      primary: '#011F1E',          // Matches primary for bold presence
      hover: '#05443E',            // Darker hover state for tactile feel
      disabled: '#8A8B8C',         // Neutral gray for disabled state
    },

    text: {
      default: '#072928',          // Readable on light background
      strong: '#000000',
      weak: '#5D5F61',
      white:'#ffffff'
    },

    stroke: {
      strong: '#02C4A1',           // Branded green
      weak: '#D3D6E0',             // Muted secondary tone
    },

    gradient: {
      secondary1: '#B6B9DA',
      primary1: '#2CFFCC',
    },

    error: '#DC2626',
    success: '#16A34A',
    warning: '#F59E0B',
    info: '#3B82F6',
  },

  font: {
    family: "'Inter', sans-serif",
    size: {
      small: '0.875rem',
      base: '1rem',
      large: '1.25rem',
    },
  },

  radius: {
    small: '6px',
    base: '12px',
    large: '20px',
  },
};









